export const FETCH_IN_OUT_ORDER_TRANS = 'FETCH_IN_OUT_ORDER_TRANS';
export const FETCH_IN_OUT_ORDER_TRANS_SUCCEED = 'FETCH_IN_OUT_ORDER_TRANS_SUCCEED';
export const FETCH_IN_OUT_ORDER_TRANS_FAILED = 'FETCH_IN_OUT_ORDER_TRANS_FAILED';

export const FETCH_IN_OUT_TRANS = 'FETCH_IN_OUT_TRANS';
export const FETCH_IN_OUT_TRANS_SUCCEED = 'FETCH_IN_OUT_TRANS_SUCCEED';
export const FETCH_IN_OUT_TRANS_FAILED = 'FETCH_IN_OUT_TRANS_FAILED';

export const FETCH_IN_OUT_TRANS_EXTERNAL = 'FETCH_IN_OUT_TRANS_EXTERNAL';
export const FETCH_IN_OUT_TRANS_EXTERNAL_SUCCEED = 'FETCH_IN_OUT_TRANS_EXTERNAL_SUCCEED';
export const FETCH_IN_OUT_TRANS_EXTERNAL_FAILED = 'FETCH_IN_OUT_TRANS_EXTERNAL_FAILED';

export const FETCH_WALLET_BALANCE = 'FETCH_WALLET_BALANCE';
export const FETCH_WALLET_BALANCE_SUCCEED = 'FETCH_WALLET_BALANCE_SUCCEED';
export const FETCH_WALLET_BALANCE_FAILED = 'FETCH_WALLET_BALANCE_FAILED';

export const FETCH_TRANS = 'FETCH_TRANS';
export const FETCH_TRANS_SUCCEED = 'FETCH_TRANS_SUCCEED';
export const FETCH_TRANS_FAILED = 'FETCH_TRANS_FAILED';

export const FETCH_EXT_TRANS = 'FETCH_EXT_TRANS';
export const FETCH_EXT_TRANS_SUCCEED = 'FETCH_EXT_TRANS_SUCCEED';
export const FETCH_EXT_TRANS_FAILED = 'FETCH_EXT_TRANS_FAILED';

export const FETCH_ORDER_TRANS = 'FETCH_ORDER_TRANS';
export const FETCH_ORDER_TRANS_SUCCEED = 'FETCH_ORDER_TRANS_SUCCEED';
export const FETCH_ORDER_TRANS_FAILED = 'FETCH_ORDER_TRANS_FAILED';

export const FETCH_IN_OUT_ORDER_TRANS_CHART = 'FETCH_IN_OUT_ORDER_TRANS_CHART';
export const FETCH_IN_OUT_ORDER_TRANS_CHART_SUCCEED = 'FETCH_IN_OUT_ORDER_TRANS_CHART_SUCCEED';
export const FETCH_IN_OUT_ORDER_TRANS_CHART_FAILED = 'FETCH_IN_OUT_ORDER_TRANS_CHART_FAILED';

export const FETCH_IN_OUT_TRANS_CHART = 'FETCH_IN_OUT_TRANS_CHART';
export const FETCH_IN_OUT_TRANS_CHART_SUCCEED = 'FETCH_IN_OUT_TRANS_CHART_SUCCEED';
export const FETCH_IN_OUT_TRANS_CHART_FAILED = 'FETCH_IN_OUT_TRANS_CHART_FAILED';

export const FETCH_IN_OUT_TRANS_EXTERNAL_CHART = 'FETCH_IN_OUT_TRANS_EXTERNAL_CHART';
export const FETCH_IN_OUT_TRANS_EXTERNAL_CHART_SUCCEED = 'FETCH_IN_OUT_TRANS_EXTERNAL_CHART_SUCCEED';
export const FETCH_IN_OUT_TRANS_EXTERNAL_CHART_FAILED = 'FETCH_IN_OUT_TRANS_EXTERNAL_CHART_FAILED';
